import { Vault } from 'nftx.js';
import Popular from './Popular';
import useCollection from '@/application/read/collections/useCollection';

const PopularContainer = ({
  vault,
  onClick,
  type,
}: {
  vault?: Pick<Vault, 'vaultId' | 'is1155' | 'asset' | 'token' | 'id'>;
  onClick: () => void;
  type: 'token' | 'collection' | 'eth';
}) => {
  const { data } = useCollection(vault?.asset.id);

  return (
    <Popular
      vault={vault}
      onClick={onClick}
      type={type}
      imageUrl={data?.image}
    />
  );
};

export default PopularContainer;
